import html from 'react-inner-html';

const HTMLRenderer = ({Content}) => (
    <div {...html(Content)}>
    
    </div>
);

export default HTMLRenderer;